module.exports = __webpack_public_path__ + "img/brand-6.67cbe8f8.png";